// Ctrl + k, o
import React, { Component } from 'react';
import { Container, Row, Col, CardTitle, Card, CardBody, CardText, CardImg } from 'reactstrap'
import Header from '../../Componentes/header'
import Nav from '../../Componentes/nav'
import Footer from '../../Componentes/footer'
import '../../CSS/bootstrap.min.css'
import '../../CSS/style.css'
import history from '../../historial'
import authImg from '../../Img/auth.png'
import userImg from '../../Img/user.png'
import documentImg from '../../Img/document.png'
import listDocumentImg from '../../Img/listDocument.png'
import moduleImg from '../../Img/module.png'
import studentImg from '../../Img/student.png'
import activityImg from '../../Img/registroActividad.png'
import groupImg from '../../Img/group.png'
import reportImg from '../../Img/Reporte.png'
import announcementImg from '../../Img/Convocatoria.png'

export default class OpcionesAdmin extends Component {
    render() {
        return (
            <html>
                <Header />
                <Row>
                    <Col className="bg-light" lg="3">
                        <Nav usuario={sessionStorage.getItem('usuario')} tipo={sessionStorage.getItem('rol')} />
                    </Col>

                    <Col className="bg-light" lg="9">
                        <div id="page-content-wrapper">
                            <div class="container-fluid">
                                <Container>
                                    <Card className="mt-3 mb-3 p-4" >
                                        <h1 className="display-4">Opciones de administrador</h1>
                                        <p className="lead">Esta seccion permite tener acceso total del sitio, modificando la informacion a su conveniencia</p>
                                        <hr className="my-1" />
                                    </Card>
                                    <Row>
                                        <Col sm="6" className="col-4 mb-4">
                                            <Card style={{ cursor: 'pointer' }} onClick={() => { history.push('/admin/pendientes') }} >
                                                <Row>
                                                    <Col sm="4">
                                                        <CardImg className="text-right" width="100%" src={authImg} alt="Card image cap" />
                                                    </Col>

                                                    <Col>
                                                        <CardBody>
                                                            <CardTitle className="font-weight-bold">Autorizaciones</CardTitle>
                                                            <CardText>Permite aceptar o negar registros de usuarios</CardText>
                                                        </CardBody>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>

                                        <Col sm="6" className="col-4 mb-4">
                                            <Card style={{ cursor: 'pointer' }} onClick={() => { history.push('/admin/usuarios') }} >
                                                <Row>
                                                    <Col sm="4">
                                                        <CardImg className="text-right" width="100%" src={userImg} alt="Card image cap" />
                                                    </Col>

                                                    <Col>
                                                        <CardBody>
                                                            <CardTitle className="font-weight-bold">Usuarios</CardTitle>
                                                            <CardText>Permite modificar datos de usuarios o accesos</CardText>
                                                        </CardBody>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>

                                        <Col sm="6" className="col-4 mb-4">
                                            <Card style={{ cursor: 'pointer' }} onClick={() => { history.push('/admin/modulos') }} >
                                                <Row>
                                                    <Col sm="4">
                                                        <CardImg className="text-right" width="100%" src={moduleImg} alt="Card image cap" />
                                                    </Col>

                                                    <Col>
                                                        <CardBody>
                                                            <CardTitle className="font-weight-bold">Modulos</CardTitle>
                                                            <CardText>Permite agregar modificar o eliminar modulos</CardText>
                                                        </CardBody>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>

                                        <Col sm="6" className="col-4 mb-4">
                                            <Card style={{ cursor: 'pointer' }} onClick={() => { history.push('/admin/estudiantes') }} >
                                                <Row>
                                                    <Col sm="4">
                                                        <CardImg className="text-right" width="100%" src={studentImg} alt="Card image cap" />
                                                    </Col>

                                                    <Col>
                                                        <CardBody>
                                                            <CardTitle className="font-weight-bold">Estudiantes</CardTitle>
                                                            <CardText>Permite agregar modificar o eliminar estudiantes</CardText>
                                                        </CardBody>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>

                                        <Col sm="6" className="col-4 mb-4">
                                            <Card style={{ cursor: 'pointer' }} onClick={() => { history.push('/admin/documentos') }} >
                                                <Row>
                                                    <Col sm="4">
                                                        <CardImg className="text-right" width="100%" src={documentImg} alt="Card image cap" />
                                                    </Col>

                                                    <Col>
                                                        <CardBody>
                                                            <CardTitle className="font-weight-bold">Documentos</CardTitle>
                                                            <CardText>Permite agregar modificar o eliminar documentos</CardText>
                                                        </CardBody>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>

                                        <Col sm="6" className="col-4 mb-4">
                                            <Card style={{ cursor: 'pointer' }} onClick={() => { history.push('/admin/docs') }} >
                                                <Row>
                                                    <Col sm="4">
                                                        <CardImg className="text-right" width="100%" src={listDocumentImg} alt="Card image cap" />
                                                    </Col>

                                                    <Col>
                                                        <CardBody>
                                                            <CardTitle className="font-weight-bold">Listado de documentos</CardTitle>
                                                            <CardText>Permite agregar modificar o eliminar documentos</CardText>
                                                        </CardBody>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>

                                        <Col sm="6" className="col-4 mb-4">
                                            <Card style={{ cursor: 'pointer' }} onClick={() => { history.push('/admin/registroActividad') }} >
                                                <Row>
                                                    <Col sm="4">
                                                        <CardImg className="text-right" width="100%" src={activityImg} alt="Card image cap" />
                                                    </Col>

                                                    <Col>
                                                        <CardBody>
                                                            <CardTitle className="font-weight-bold">Registro de actividad</CardTitle>
                                                            <CardText>Permite visualizar cada movimiento realizado por los alumnos</CardText>
                                                        </CardBody>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>

                                        <Col sm="6" className="col-4 mb-4">
                                            <Card style={{ cursor: 'pointer' }} onClick={() => { history.push('/admin/grupos') }} >
                                                <Row>
                                                    <Col sm="4">
                                                        <CardImg className="text-right" width="100%" src={groupImg} alt="Card image cap" />
                                                    </Col>

                                                    <Col>
                                                        <CardBody>
                                                            <CardTitle className="font-weight-bold">Grupos</CardTitle>
                                                            <CardText>Permite administrar el contenido de los grupos</CardText>
                                                        </CardBody>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>

                                        <Col sm="6" className="col-4 mb-4">
                                            <Card style={{ cursor: 'pointer' }} onClick={() => { history.push('/admin/aspirantes') }} >
                                                <Row>
                                                    <Col sm="4">
                                                        <CardImg className="text-right" width="100%" src={groupImg} alt="Card image cap" />
                                                    </Col>

                                                    <Col>
                                                        <CardBody>
                                                            <CardTitle className="font-weight-bold">Aspirantes</CardTitle>
                                                            <CardText>Permite administrar los perfiles de aspirantes</CardText>
                                                        </CardBody>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>

                                        <Col sm="6" className="col-4 mb-4">
                                            <Card style={{ cursor: 'pointer' }} onClick={() => { history.push('/admin/reporteador') }} >
                                                <Row>
                                                    <Col sm="4">
                                                        <CardImg className="text-right" width="100%" src={reportImg} alt="Card image cap" />
                                                    </Col>

                                                    <Col>
                                                        <CardBody>
                                                            <CardTitle className="font-weight-bold">Reportes</CardTitle>
                                                            <CardText>Permite generar reportes de estado de la base de datos</CardText>
                                                        </CardBody>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>

                                        <Col sm="6" className="col-4 mb-4">
                                            <Card style={{ cursor: 'pointer' }} onClick={() => { history.push('/admin/convocatoria') }} >
                                                <Row>
                                                    <Col sm="4">
                                                        <CardImg className="text-right" width="100%" src={announcementImg} alt="Card image cap" />
                                                    </Col>

                                                    <Col>
                                                        <CardBody>
                                                            <CardTitle className="font-weight-bold">Convocatorias</CardTitle>
                                                            <CardText>Permite administrar diversas convocatorias y sus respectivas etapas</CardText>
                                                        </CardBody>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>

                                        <Col sm="6" className="col-4 mb-4">
                                            <Card style={{ cursor: 'pointer' }} onClick={() => { history.push('/admin/subirABaseDatos') }} >
                                            <Row>
                                                <Col sm="4">
                                                    <CardImg className="text-right" width="100%" src={groupImg} alt="Card image cap" />
                                                </Col>
                                                <Col>
                                                <CardBody>
                                                    <CardTitle className="font-weight-bold">Subir a Base de datos</CardTitle>
                                                    <CardText>Permite subir informacion mediante hojas de calculo</CardText>
                                                </CardBody>
                                                </Col>
                                            </Row>
                                        </Card>
                                        </Col>
                                        
                                        <Col sm="6" className="col-4 mb-4">
                                            <Card style={{ cursor: 'pointer' }} onClick={() => { history.push('/admin/funciones') }} >
                                            <Row>
                                                <Col sm="4">
                                                    <CardImg className="text-right" width="100%" src={groupImg} alt="Card image cap" />
                                                </Col>
                                                <Col>
                                                <CardBody>
                                                    <CardTitle className="font-weight-bold">Funciones</CardTitle>
                                                    <CardText>Permite ejecutar tareas de orden mayor</CardText>
                                                </CardBody>
                                                </Col>
                                            </Row>
                                        </Card>
                                        </Col>

                                    </Row>
                                </Container>
                            </div>
                        </div>
                    </Col>

                </Row>
                <Footer />
            </html>
        )
    }
}
